import { render, staticRenderFns } from "./coderProjectHeader.vue?vue&type=template&id=ab6d0f60&scoped=true&"
import script from "./coderProjectHeader.vue?vue&type=script&lang=js&"
export * from "./coderProjectHeader.vue?vue&type=script&lang=js&"
import style0 from "./coderProjectHeader.vue?vue&type=style&index=0&id=ab6d0f60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6d0f60",
  null
  
)

export default component.exports